"use strict";

var _interopRequireDefault = require("D:/www/ssz_gold_backend/multi_merchant_web/gold_admin/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.sub");

require("core-js/modules/es6.regexp.split");

var _system = require("@/api/system");

var _merchant = require("@/api/merchant");

var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));

var _editCategory = _interopRequireDefault(require("@/components/merchant/editCategory"));

var _validate = require("@/utils/validate");

var _index = require("@/api/index");

var _info = require("@/api/info");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['id'],
  components: {
    cropUpload: _cropUpload.default,
    editCategory: _editCategory.default
  },
  data: function data() {
    var _this = this;

    var validateMobile = function validateMobile(rule, value, callback) {
      if (!(0, _validate.checkMobile)(value)) {
        callback(new Error('手机号格式错误'));
      } else {
        callback();
      }
    };

    var validateConfirm = function validateConfirm(rule, value, callback) {
      if (value !== _this.form.pwd) {
        callback(new Error('两次输入密码不同！'));
      } else {
        callback();
      }
    };

    var validatePwd = function validatePwd(rule, value, callback) {
      var reg = /^[^\u4e00-\u9fa5]{0,}$/;

      if (value && value.length < 6) {
        callback(new Error('密码必须大于等于6个字符'));
      } else if (!reg.test(value)) {
        callback(new Error('密码不能包含汉字！'));
      } else {
        callback();
      }
    };

    return {
      infoData: {
        photo: ''
      },
      form: {
        username: "",
        pwd: "",
        confirmPwd: "",
        role_id: null,
        mobile: "",
        status: 0
      },
      roleList: [],
      psnAuthUrl: '',
      orgAuthUrl: '',
      sealAuthUrl: '',
      statusList: [{
        id: 0,
        title: '禁用'
      }, {
        id: 1,
        title: '启用'
      }],
      regionList: [],
      shopcity: '',
      companyArea: [],
      optionProps: {
        value: 'name',
        label: 'name',
        expandTrigger: 'hover',
        children: 'sub'
      },
      editItem: {},
      categoryList: [],
      rules: {
        mobile: [{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur'
        }, {
          validator: validateMobile,
          trigger: 'blur'
        }],
        username: [{
          required: true,
          message: '用户名不能为空',
          trigger: 'blur'
        }],
        pwd: [{
          required: true,
          message: '密码不能为空',
          trigger: 'blur'
        }, {
          validator: validatePwd,
          trigger: 'blur'
        }],
        confirmPwd: [{
          required: true,
          message: '重复密码不能为空',
          trigger: 'blur'
        }, {
          validator: validateConfirm,
          trigger: 'blur'
        }],
        role_id: [{
          required: true,
          message: '请选择角色',
          trigger: 'change'
        }]
      },
      rules1: {
        mobile: [{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur'
        }, {
          validator: validateMobile,
          trigger: 'blur'
        }],
        username: [{
          required: true,
          message: '用户名不能为空',
          trigger: 'blur'
        }],
        pwd: [{
          validator: validatePwd,
          trigger: 'blur'
        }],
        confirmPwd: [{
          validator: validateConfirm,
          trigger: 'blur'
        }] // role_id: [{ required: true, message: '请选择角色', trigger: 'change' }],

      }
    };
  },
  computed: {
    viewTitle: function viewTitle() {
      return this.id > 0 ? "查看" : "添加";
    }
  },
  created: function created() {
    if (this.id > 0) {
      this.getMerchantAccount();
      this.getData();
      this.getCategoryList();
    }

    this.getProvice();
    this.getRoleList();
  },
  methods: {
    getMerchantAccount: function getMerchantAccount() {
      var _this2 = this;

      (0, _merchant.getMerchantAccount)(this.id).then(function (res) {
        // console.log('getMerchantAccount', res)
        _this2.form = {
          id: res.id,
          username: res.username,
          mobile: res.mobile,
          role_id: res.role_id,
          status: res.status
        };
      });
    },
    getData: function getData() {
      var _this3 = this;

      // console.log('id', this.id)
      (0, _merchant.getMerchantInfo)(this.id).then(function (res) {
        _this3.infoData = res || {};

        if (_this3.infoData.shopcity) {
          _this3.shopcity = _this3.infoData.shopcity;

          var cityArr = _this3.infoData.shopcity.split('-');

          _this3.infoData.shopcity = cityArr[0] && cityArr[1] && cityArr[2] ? cityArr : [];
        }

        if (_this3.infoData.company_area) {
          _this3.companyArea = _this3.infoData.company_area.split('-');
        }
      });
    },
    getCategoryList: function getCategoryList() {
      var _this4 = this;

      (0, _info.categoryList)().then(function (res) {
        _this4.categoryList = res.data;
        console.log(res.data);
      });
    },
    getProvice: function getProvice() {
      var _this5 = this;

      (0, _index.getRegion)().then(function (res) {
        _this5.regionList = res ? res[0].sub : [];
      });
    },
    getRoleList: function getRoleList() {
      var _this6 = this;

      (0, _merchant.getMerchantAdminGruopList)().then(function (res) {
        _this6.roleList = res || [];
      });
    },
    changeNumberInput: function changeNumberInput(value) {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时

      if (!pattern.test(value)) {
        // input 框绑定的内容为空
        this.infoData.mobile = '';
      }
    },
    openCategory: function openCategory() {
      this.editItem = {
        id: this.id,
        category_ids: this.infoData.category_ids ? this.infoData.category_ids : ''
      };
      this.$refs.editCategory.dialogVisible = true;
    },
    handleSubmitData: function handleSubmitData() {
      var data = this.infoData;

      for (var key in data) {
        if (!data[key]) {
          delete data[key];
        }
      }

      if (this.companyArea.length) {
        data.company_area = this.companyArea.join('-');
      }

      console.log('handleSubmitData', data);
      return data;
    },
    submit: function submit() {
      var _this7 = this;

      console.log('submit');
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          var infoData = _this7.handleSubmitData();

          if (infoData.category_list) {
            delete infoData.category_list;
          }

          if (_this7.id > 0) {
            (0, _system.editMerchant)({
              id: _this7.form.id,
              username: _this7.form.username,
              pwd: _this7.form.pwd ? _this7.$md5(_this7.form.pwd) : "",
              role_id: _this7.form.role_id,
              status: _this7.form.status,
              infoData: infoData
            }).then(function (res) {});
          } else {
            (0, _system.addMerchant)({
              mobile: _this7.form.mobile,
              username: _this7.form.username,
              pwd: _this7.$md5(_this7.form.pwd),
              role_id: _this7.form.role_id,
              status: _this7.form.status,
              infoData: infoData
            }).then(function (res) {
              setTimeout(function () {
                _this7.$router.back();
              }, 3000);
            });
          }
        } else {
          _this7.$message({
            message: "请检查表单错误",
            type: "error"
          });

          return false;
        }
      });
    },
    imgChange: function imgChange(val, key) {
      this.infoData[key] = val;

      if (this.infoData.id && val) {
        var param = {
          id: this.infoData.id
        };
        param[key] = val;
        (0, _merchant.editMerchantInfo)(param).then(function (res) {// this.infoData.photo = val;
        });
      }
    },
    getEsignPsnId: function getEsignPsnId() {
      var _this8 = this;

      (0, _merchant.getEsignPsnId)({
        id: this.id
      }).then(function (res) {
        console.log('getEsignPsnId-res', res);

        if (res.data) {
          _this8.psnAuthUrl = res.data.authShortUrl;
        } else {
          _this8.getData();
        }
      }).catch(function (err) {});
    },
    getEsignOrgId: function getEsignOrgId() {
      var _this9 = this;

      (0, _merchant.getEsignOrgId)({
        id: this.id
      }).then(function (res) {
        console.log('getEsignOrgId-res', res);

        if (res.data) {
          _this9.orgAuthUrl = res.data.authShortUrl;
        } else {
          _this9.getData();
        }
      }).catch(function (err) {});
    },
    getEsignSealId: function getEsignSealId() {
      var _this10 = this;

      (0, _merchant.getEsignSealId)({
        id: this.id
      }).then(function (res) {
        console.log('getEsignSealId-res', res);

        if (res.data) {
          _this10.sealAuthUrl = res.data.authorizationSignShortUrl;
        } else {
          _this10.getData();
        }
      }).catch(function (err) {});
    },
    handleMobileChange: function handleMobileChange() {
      this.form.mobile = this.form.mobile.replace(/[^\d]/g, "");
    }
  }
};
exports.default = _default;